<header class="header">
  <div (click)="logout()">
    <img src="./assets/images/auto_idea_logo.png" alt="Auto Idea" height="48" />
  </div>
</header>